import { useState, useEffect, useRef, useCallback } from 'react'

import { Link, useLocation } from 'react-router-dom'

import { PiUserCircleGear } from 'react-icons/pi'
import { IoTriangle } from 'react-icons/io5'

import IfPath from './IfPath'
import Spinner    from '../Spinners/Spinner'

import nodeIsOrBelongsTo from '../Functions/nodeIsOrBelongsTo'
import request           from '../Functions/ajax/request'
import bemit             from '../Functions/bemit'

import RolesStore from '../../Stores/Roles'

import setAccountStore from '../../StoresFunctions/setAccountStore'
import setRolesStore   from '../../StoresFunctions/setRolesStore'
import setPagesStore   from '../../StoresFunctions/setPagesStore'

const ORDERS_PAGE_PATH = '/mon-compte/commandes-et-devis';
const ADMIN_PAGE = '/admin/accueil';
const MANAGEMENT_PAGE = '/gestion/accueil';

export default function UserMenu ({ ...props })
{
	const roles = RolesStore.useState(store => store.roles);

	const location = useLocation();

	const [open, setOpen] = useState(false);
	const [disconnecting, setDisconecting] = useState(false);

	const ref = useRef();

	useEffect(function ()
	{
		if (open !== true) return;

		document.addEventListener('click', listener);

		return () => document.removeEventListener('click', listener);

		function listener (e)
		{
		// ignore le click s'il est dans le menu, on le ferme sinon
			if (nodeIsOrBelongsTo(e?.target, ref.current)) return;

			setOpen(false);
		}
	},
	[open]);

	const logout = useCallback(function (e)
	{
		const controller = new AbortController();

		setDisconecting(true);

		(async function logout ()
		{
			try
			{
				var { pages, version } = await request('/auth/logout')
				.config({ controller })
				.post();
			}
			catch (update)
			{
				if (controller?.signal?.aborted) return;
				return;
			}

			setPagesStore({ pages, version });
			setAccountStore({ });
			setRolesStore({ });

			setDisconecting(false);

			window.location.href = '/espace-pro';
		})();

		return () => controller?.abort?.();
	},
	[]);

	useEffect(function ()
	{
		setOpen(false);
	},
	[location.pathname]);

	if (roles.length === 0)
	{
		return (
			<Link type="button" className="o-user-menu__toggle"
				to="/espace-pro">
				<PiUserCircleGear className="o-user-menu__toggle-icon" />
				<span className="u-readers-only">
					Menu
				</span>
			</Link>
		);
	}

	const orders_page =
	(
		<IfPath path={ ORDERS_PAGE_PATH }>
			<li className="o-user-menu__list-item">
				<Link to={ ORDERS_PAGE_PATH }
					className="o-user-menu__list-btn">
					<span className="o-user-menu__list-btn-txt">
						Commandes et devis
					</span>
				</Link>
			</li>
		</IfPath>
	);

	const admin_page =
	(
		<IfPath path={ ADMIN_PAGE }>
			<li className="o-user-menu__list-item">
				<Link to={ ADMIN_PAGE }
					className="o-user-menu__list-btn">
					<span className="o-user-menu__list-btn-txt">
						Administration
					</span>
				</Link>
			</li>
		</IfPath>
	);

	const management_page =
	(
		<IfPath path={ MANAGEMENT_PAGE }>
			<li className="o-user-menu__list-item">
				<Link to={ MANAGEMENT_PAGE }
					className="o-user-menu__list-btn">
					<span className="o-user-menu__list-btn-txt">
						Gestion
					</span>
				</Link>
			</li>
		</IfPath>
	);

	return (
		<div className={ bemit('o-user-menu', ['front']) } ref={ ref }>
			<button type="button" className="o-user-menu__toggle"
				onClick={ e => setOpen(state => !state) }>
				<PiUserCircleGear className="o-user-menu__toggle-icon" />
				<span className="u-readers-only">
					Menu
				</span>
			</button>

			<ul className="o-user-menu__list" aria-hidden={ !open }>

				<IfPath path="/mon-compte">
					<li className="o-user-menu__list-item">
						<Link to="/mon-compte"
							className="o-user-menu__list-btn">
							<span className="o-user-menu__list-btn-txt">
								Mon compte
							</span>
						</Link>
					</li>
				</IfPath>

				{ orders_page }

				{ admin_page }

				{ management_page }

				<li className="o-user-menu__list-item">
					<button type="button" className="o-user-menu__list-btn"
						onClick={ logout }>
						<span className="o-user-menu__list-btn-txt">
							Déconnexion
						</span>
						<Spinner active={ disconnecting }
							bemit={ ['bg-white', 'primary'] }
						/>
					</button>
				</li>
			</ul>

			<IoTriangle className="o-user-menu__rect" />
		</div>
	);
}